import { AppBar, Box } from "@mui/material";
import { KeyDriveh4Header } from "../KeydriveComponents/Fonts/Headers/KeyDriveh4Header";
import { KeyDriveCaption } from "../KeydriveComponents/Fonts/Captions/KeyDriveCaption";
import { KeyDrivePrimaryButton } from "../KeydriveComponents/Buttons/KeyDrivePrimaryButton";
import { ArrowForwardIos } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { useProfile } from "../../context/ProfileProvider/useProfile";
import { useEffect, useState } from "react";
import { GetOneOrganization } from "../../services/OrganizationServices";

interface IFreeSoftwareAlert {
    isCollapsed: boolean;
    nameOrg: string;
}

export default function FreeSoftwareAlert({
    isCollapsed,
    nameOrg
}: IFreeSoftwareAlert) {

    const navigate = useNavigate();
    const [isAdmin, setIsAdmin] = useState<boolean>(false);
    const profile = useProfile();

    useEffect(() => {
        if (nameOrg) {
            GetOneOrganization(nameOrg)
            .then(res => {
                setIsAdmin(res?.adminUsers?.includes(profile?.id!)!);
            })
            .catch(() => {
                setIsAdmin(false);
            })
        }
    }, [nameOrg]);

    if (nameOrg == undefined) {
        return <></>
    }

    return (
        <AppBar
            sx={{
                width: `${isCollapsed ? "calc(100% - 66px)" : "calc(100% - 220px)"}`,
                height: "50px",
                marginTop: "66px",
                backgroundColor: "#22638D",
                padding: "4px",
                zIndex: "-1 !important"
            }}
        >
            <Box    
                width="100%"
                height="100%"
                display="flex"
                justifyContent="space-between"
            >
                <Box>
                    <KeyDriveh4Header 
                        text="Você está usando uma versão gratuita do software"
                        color="#E8EFF3"
                        needBold={false}
                        needEllipses={false}
                    />
                    <KeyDriveCaption 
                        text={isAdmin ? "Para atualizar, entre no admin console e acesse nossa aba de planos!" : "Para atualizar, entre em contato com o administrador da sua organização!"}
                        color="#E8EFF3"
                        needBold={false}
                        needEllipses={false}
                    />
                </Box>
                { isAdmin && (
                    <KeyDrivePrimaryButton
                        endIcon={<ArrowForwardIos />}
                        width="250px"
                        TextComponent={KeyDriveCaption}
                        TextComponentProps={{
                            color: "#E8EFF3",
                            needBold: false,
                            needEllipses: false,
                            text: "Acessar Planos"
                        }}
                        needFullWidth={false}
                        backgroundColor="#F58601"
                        disabled={nameOrg == undefined}
                        onClick={()=> {
                            navigate(`${nameOrg}/adminConsole/plans`);
                        }}
                    />
                ) }
            </Box>
        </AppBar>
    )
}